import { render, staticRenderFns } from "./InfoDialog.vue?vue&type=template&id=2a1dc282&scoped=true"
import script from "./InfoDialog.vue?vue&type=script&lang=ts"
export * from "./InfoDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1dc282",
  null
  
)

export default component.exports